export default ({ comments, value }) => ({
  comments,
  ...value,
});
